const InGameShopData = {
  frames: [
    {
      id: 3,
      name: "Colnago V4Rs UAE",
      description: "Colnago V4Rs UAE Team Emirates, built to win! Lighter, stiffer and more Aero. Developed from feedback and testing of the worlds best riders, the Colnago V4Rs took the best bike and made it better.",
      aerodynamics: 60,
      weight: 5.9,
      thumbnail: "/assets/images/shop/Frames/Colnago V4Rs UAE.png"
    },
    {
      id: 4,
      name: "Colnago V4Rs ADQ",
      description: "Colnago V4Rs Team ADQ, built to win! Lighter, stiffer and more Aero. Developed from feedback and testing of the worlds best riders, the Colnago V4Rs took the best bike and made it better.",
      aerodynamics: 60,
      weight: 5.9,
      thumbnail: "/assets/images/shop/Frames/Colnago V4Rs ADQ.png"
    },
    {
      id: 5,
      name: "Colnago V3Rs",
      description: "Colnago V3Rs Red is a true racing frame, no compromises. Every detail has been studied and developed to obtain the maximum in terms of performance while keeping an eye to comfort. ",
      aerodynamics: 55,
      weight: 5.9,
      thumbnail: "/assets/images/shop/Frames/Colnago V3Rs.png"
    },
    {
      id: 7,
      name: "Colnago C68",
      description: "The C68 represents the history of a company that has collected successes and innovations for more than 68 years. Lighter, stiffer, and faster than previous models, the C68 is for the true cycling enthusiast, seeking performance and something unique. ",
      aerodynamics: 55,
      weight: 5.8,
      thumbnail: "/assets/images/shop/Frames/Colnago C68.png"
    },
    {
      id: 11,
      name: "Colnago TT1",
      description: "The Prototype Colnago TT1 continues the development of iconic and desirable bikes with exceptional performance. Developed through extensive testing in the wind tunnel, Colnago has obtained unprecedented results in terms of performance at high speeds.",
      aerodynamics: 90,
      weight: 7.2,
      thumbnail: "/assets/images/shop/Frames/Colnago TT1.png"
    },
    {
      id: 13,
      name: "Ventum NS1",
      description: "Ventum NS1, pure road performance. A bike designed for speed and ride quality. Its stiff, nimble, and responsive frame lets the road disappear beneath your tires.",
      aerodynamics: 65,
      weight: 6.1,
      thumbnail: "/assets/images/shop/Frames/Ventum NS1.png"
    },
    {
      id: 14,
      name: "Ventum GS1",
      description: "Ventum GS1 takes you further and faster wherever you choose to ride. Dynamic, exciting and aesthetically stunning, the GS1 is a bike that handles any adventure you choose to take.",
      aerodynamics: 50,
      weight: 6.2,
      thumbnail: "/assets/images/shop/Frames/Ventum GS1.png"
    },
    {
      id: 15,
      name: "Look 795 Blade",
      description: "Look 795 Blade RS, more technology, outstanding aerodynamics. The 795 encompasses all of LOOK's expertise for premium stiffness, comfort and aerodynamics while retaining its superlight frame. The fastest and most comfortable Look bike ever designed.",
      aerodynamics: 65,
      weight: 6,
      thumbnail: "/assets/images/shop/Frames/Look 795 Blade.png"
    },
    {
      id: 16,
      name: "Look 785 Chameleon",
      description: "With its modern, aggressive design and upgraded setup,  the 785 Chameleon Huez RS offers performance and aerodynamics in a lightweight package. Perfect for blasting up your next climb!",
      aerodynamics: 50,
      weight: 5.8,
      thumbnail: "/assets/images/shop/Frames/Look 785 Chameleon.png"
    },
    {
      id: 17,
      name: "BMC SLR 01 One",
      description: "The Teammachine SLR 01 One incorporates a TCC Race-engineered Premium Carbon frame, SRAM RED AXS Drivetrain, Aerocore Design system, ICS technology and Stealth Cable Routing. Lighter, faster and more responsive, the Teammachine SLR 01 still leads where others follow.",
      aerodynamics: 60,
      weight: 5.8,
      thumbnail: "/assets/images/shop/Frames/BMC SLR 01 One.png"
    },
    {
      id: 18,
      name: "BMC SLR 01 Two",
      description: "The Teammachine SLR 01 Two incorporates a TCC Race-engineered Premium Carbon frame, Shimano Dura-Ace Drivetrain, Aerocore Design system, ICS technology and Stealth Cable Routing. Lighter, faster and more responsive, the Teammachine SLR 01 still leads where others follow.",
      aerodynamics: 60,
      weight: 5.9,
      thumbnail: "/assets/images/shop/Frames/BMC SLR 01 Two.png"
    },
    {
      id: 19,
      name: "Van Rysel RCR",
      description: "Van Rysel RCR was developed to be aerodynamic, light, stiff and to win at the highest level. Whether you’re an amateur or a top level professional this bike offers efficient performance in both flat and mountainous terrain and is designed for a single purpose: to win.",
      aerodynamics: 55,
      weight: 6,
      thumbnail: "/assets/images/shop/Frames/Van Rysel RCR.png"
    },
    {
      id: 24,
      name: "Colnago V4Rs Giro edition",
      description: "Colnago V4Rs build to win. Designed to celebrate Tadej Pogacar win in the 2024 Giro d’Italia",
      aerodynamics: 60,
      weight: 5.9,
      thumbnail: "/assets/images/shop/Frames/Colnago V4Rs Giro edition.png"
    },
    {
      id: 26,
      name: "ENVE Melee Aegean Blue",
      description: "A modern road racer that delivers on ENVE's Real-World Fast design philosophy. Agile and responsive, the Melee Aegean Blue is ready for racing and adventure.",
      aerodynamics: 60,
      weight: 6,
      thumbnail: "/assets/images/shop/Frames/ENVE Melee Aegean Blue.png"
    },
    {
      id: 27,
      name: "ENVE Melee Damascus",
      description: "A modern road racer that delivers on ENVE's Real-World Fast design philosophy. Agile and responsive, the Melee Damascus Silver is ready for racing and adventure.",
      aerodynamics: 60,
      weight: 6,
      thumbnail: "/assets/images/shop/Frames/ENVE Melee Damascus.png"
    },
    {
      id: 28,
      name: "Giant TCR Advanced SL",
      description: "The World Tour Level TCR Advanced SL is the pro's choice for all-rounder performance. Delivering system integration and innovative construction methods to deliver a clear advantage on the road.",
      aerodynamics: 65,
      weight: 6,
      thumbnail: "/assets/images/shop/Frames/Giant TCR Advanced SL.png"
    },
    {
      id: 29,
      name: "Liv Langma Advanced SL",
      description: "The queen of all-rounder performance. The Langma Advanced SL has a race-engineered frameset and integrated components, delivering efficient power transfer to rule the mountains, and the aerodynamics to finish in a blur of glory.",
      aerodynamics: 65,
      weight: 6,
      thumbnail: "/assets/images/shop/Frames/Liv Langma Advanced SL.png"
    },
    {
      id: 30,
      name: "Colnago Fleur-de-Lys C68",
      description: "The name and the livery of gold fleurs-de-lys on a blue field,  a heraldic element symbolising royalty and pride. Lighter, stiffer, and faster than previous models, the C68 is for the true cycling enthusiast, seeking performance and something unique.",
      aerodynamics: 55,
      weight: 5.8,
      thumbnail: "/assets/images/shop/Frames/Colnago Fleur-de-Lys C68.png"
    },
    {
      id: 31,
      name: "Colnago V4Rs TDF edition",
      description: "Colnago V4Rs build to win. Designed to celebrate Tadej Pogacar win in the 2024 Tour de France",
      aerodynamics: 60,
      weight: 5.9,
      thumbnail: "/assets/images/shop/Frames/Colnago V4Rs TDF edition.png"
    }
  ],
  wheels: [
    {
      id: 1,
      name: "MyWhoosh SC-30",
      description: "Standard Carbon 30mm wheelset. Aimed at saving weight and designed with the hills in mind.",
      aerodynamics: 20,
      weight: 1.35,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh SC-30.png"
    },
    {
      id: 2,
      name: "MyWhoosh SC-50",
      description: "Standard Carbon 50mm wheelset. A balanced blend of weight and aero. Your all-round wheelset.",
      aerodynamics: 30,
      weight: 1.45,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh SC-50.png"
    },
    {
      id: 3,
      name: "MyWhoosh SC-65",
      description: "Standard Carbon 65mm wheelset. A wheelset that reduces drag with deep-section rims that optimizes aero efficiency for flat-out speed.",
      aerodynamics: 50,
      weight: 1.55,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh SC-65.png"
    },
    {
      id: 4,
      name: "MyWhoosh SC-Aero",
      description: "Standard Carbon Aero Disc wheelset. Fast and Aero, this wheelset combines a 65mm Standard Carbon front wheel with an Aero Disc rear wheel. Ride these when speed is the focus!",
      aerodynamics: 70,
      weight: 1.65,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh SC-Aero.png"
    },
    {
      id: 5,
      name: "MyWhoosh SC-Gravel",
      description: "Standard Carbon Gravel Wheelset. All-road performance, light, aerodynamic and capable of going wherever you choose.",
      aerodynamics: 20,
      weight: 1.4,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh SC-Gravel.png"
    },
    {
      id: 6,
      name: "Corima MCC DX 47mm",
      description: "Corima MCC DX 47mm. Lightweight for fast climbing, optimal stiffness for improved performance, an unprecedented level of responsiveness for fast acceleration and optimized aerodynamics. The MCC DX pushes the limits of performance.",
      aerodynamics: 50,
      weight: 1.35,
      thumbnail: "/assets/images/shop/wheels/Corima MCC DX 47mm.png"
    },
    {
      id: 7,
      name: "Corima Essentia 40",
      description: "Corima Essentia 40 is the ultimate all-road wheel. Destined to erase the borders between road and gravel, fast, lightweight, ultra-versatile. With hookless rims and wider tires it is designed to maximize comfort and control.",
      aerodynamics: 30,
      weight: 1.4,
      thumbnail: "/assets/images/shop/wheels/Corima Essentia 40.png"
    },
    {
      id: 8,
      name: "Swiss Side Hadron Ultimate 500",
      description: "Swiss Side Hadron Ultimate 500, perfectly engineered stiffness to weight ratio, tubeless ready, hooked construction, designed to deliver the optimum balance of rolling resistance and aero performance.",
      aerodynamics: 60,
      weight: 1.35,
      thumbnail: "/assets/images/shop/wheels/Swiss Side Hadron Ultimate 500.png"
    },
    {
      id: 9,
      name: "MyWhoosh SC-40 Desert Sand",
      description: "Standard Carbon 40mm wheelset. Light, stiff and fast on the desert flats.",
      aerodynamics: 30,
      weight: 1.35,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh SC-40 Desert Sand.png"
    },
    {
      id: 10,
      name: "MyWhoosh PC-44 Rouleur",
      description: "Premium Carbon 44mm wheelset. Designed with a focus on aerodynamics and handling, the ability to go fast on any road.",
      aerodynamics: 50,
      weight: 1.3,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh PC-44 Rouleur.png"
    },
    {
      id: 11,
      name: "MyWhoosh PC-40 Radiance",
      description: "Premium Carbon 40mm wheelset. Lightweight and responsive, a premium wheelset designed to go fast.",
      aerodynamics: 50,
      weight: 1.25,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh PC-40 Radiance.png"
    },
    {
      id: 12,
      name: "MyWhoosh PC-40 Desert Sand",
      description: "Premium Carbon 40mm wheelset. Lightweight and responsive, a premium wheelset designed to go fast.",
      aerodynamics: 50,
      weight: 1.25,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh PC-40 Desert Sand.png"
    },
    {
      id: 13,
      name: "ENVE Pink decals",
      description: "Designed to deliver more speed in a lighter package with pink touch to celebrate Tadej Pogacar win in the 2024 Giro d’Italia",
      aerodynamics: 30,
      weight: 1.45,
      thumbnail: "/assets/images/shop/wheels/ENVE Pink decals.png"
    },
    {
      id: 15,
      name: "ENVE SES 4.5",
      description: "Designed to deliver more speed in a lighter package. When speed across most any terrain is priority number one, look no further than the ENVE SES 4.5.",
      aerodynamics: 65,
      weight: 1.45,
      thumbnail: "/assets/images/shop/wheels/ENVE SES 4.5.png"
    },
    {
      id: 16,
      name: "Cadex 50 Ultra Disc",
      description: "Climbs and descents. Fast, flat sections and tricky corners. Group dynamics and solo moves. The new CADEX 50 Ultra Disc Wheelset targets all these factors.",
      aerodynamics: 60,
      weight: 1.3,
      thumbnail: "/assets/images/shop/wheels/Cadex 50 Ultra Disc.png"
    },
    {
      id: 17,
      name: "MyWhoosh PC-38 Sapphire",
      description: "MyWhoosh PC-38 Sapphire is a lightweight, high-end carbon wheelset crafted to distinguish itself with exceptional design and maximum performance.",
      aerodynamics: 55,
      weight: 1.4,
      thumbnail: "/assets/images/shop/wheels/Cadex 50 Ultra Disc.png"
    },
    {
      id: 18,
      name: "MyWhoosh PC-38 FireOpal",
      description: "MyWhoosh PC-38 FireOpal is a lightweight, high-end carbon wheelset crafted to distinguish itself with exceptional design and maximum performance.",
      aerodynamics: 55,
      weight: 1.4,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh PC-38 FireOpal.png"
    },
    {
      id: 19,
      name: "MyWhoosh PC-38 Emerald",
      description: "MyWhoosh PC-38 Emerald is a lightweight, high-end carbon wheelset crafted to distinguish itself with exceptional design and maximum performance.",
      aerodynamics: 55,
      weight: 1.4,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh PC-38 Emerald.png"
    },
    {
      id: 20,
      name: "MyWhoosh PC-38 Amethyst",
      description: "MyWhoosh PC-38 Amethyst is a lightweight, high-end carbon wheelset crafted to distinguish itself with exceptional design and maximum performance.",
      aerodynamics: 55,
      weight: 1.4,
      thumbnail: "/assets/images/shop/wheels/MyWhoosh PC-38 Amethyst.png"
    },
    {
      id: 21,
      name: "ENVE SES 4.5 Gold",
      description: "Designed to deliver more speed in a lighter package. When speed across most any terrain is priority number one, look no further than the ENVE SES 4.5.",
      aerodynamics: 65,
      weight: 1.3,
      thumbnail: "/assets/images/shop/wheels/ENVE SES 4.5 Gold.png"
    },
    {
      id: 22,
      name: "ENVE SES 4.5 TDF Edition",
      description: "Designed to deliver more speed in a lighter package with Yellow touch to celebrate Tadej Pogacar win in the 2024 Tour de France.",
      aerodynamics: 65,
      weight: 1.3,
      thumbnail: "/assets/images/shop/wheels/ENVE SES 4.5 TDF Edition.png"
    }
  ],
  helmet: [
    {
      id: 2,
      name: "MyWhoosh Road Helmet",
      description: "MyWhoosh Road Helmet delivers ample ventilation with aerodynamic efficiency. To keep you cool and cut through the air more smoothly, improving speed and performance.",
      weight: 110,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Road Helmet- Black.png"
    },
    {
      id: 3,
      name: "MyWhoosh Road Helmet",
      description: "MyWhoosh Road Helmet delivers ample ventilation with aerodynamic efficiency. To keep you cool and cut through the air more smoothly, improving speed and performance.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Road Helmet - White.png"
    },
    {
      id: 4,
      name: "MyWhoosh Road Aero Helmet",
      description: "MyWhoosh Road Aero Helmet has a lightweight construction and aerodynamic profile that helps reduce air resistance, enhancing overall speed.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Road Aero Helmet - Black.png"
    },
    {
      id: 5,
      name: "MyWhoosh Road Aero Helmet",
      description: "MyWhoosh Road Aero Helmet has a lightweight construction and aerodynamic profile that helps reduce air resistance, enhancing overall speed.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Road Aero Helmet - White.png"
    },
    {
      id: 6,
      name: "MyWhoosh Road Helmet",
      description: "MyWhoosh Road Helmet delivers ample ventilation with aerodynamic efficiency. To keep you cool and cut through the air more smoothly, improving speed and performance.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Road Helmet - Yellow.png"
    },
    {
      id: 14,
      name: "MyWhoosh Standard Cycling Cap",
      description: "MyWhoosh Standard Cycling Cap features a short brim, sweat-absorbing band, and a compact design, adding a touch of style to your apparel.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Standard Cycling Cap - Yellow.png"
    },
    {
      id: 15,
      name: "MyWhoosh Standard Cycling Cap",
      description: "MyWhoosh Standard Cycling Cap features a short brim, sweat-absorbing band, and a compact design, adding a touch of style to your apparel.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Standard Cycling Cap - White.png"
    },
    {
      id: 16,
      name: "MyWhoosh Standard Cycling Cap",
      description: "MyWhoosh Standard Cycling Cap features a short brim, sweat-absorbing band, and a compact design, adding a touch of style to your apparel.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Standard Cycling Cap - Blue.png"
    },
    {
      id: 17,
      name: "MyWhoosh Fluro Cycling Cap",
      description: "MyWhoosh Fluro Cycling Cap features a short brim, sweat-absorbing band, and a compact design, adding a touch of style to your apparel.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Fluro Cycling Cap.png"
    },
    {
      id: 18,
      name: "MyWhoosh Polka Dot Cycling Cap",
      description: "MyWhoosh Polka Dot Cycling Cap features a short brim, sweat-absorbing band, and a compact design, adding a touch of style to your apparel.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Polka Dot Cycling Cap.png"
    },
    {
      id: 19,
      name: "MyWhoosh Stripes Cycling Cap",
      description: "MyWhoosh Stripes Cycling Cap features a short brim, sweat-absorbing band, and a compact design, adding a touch of style to your apparel.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Stripes Cycling Cap.png"
    },
    {
      id: 20,
      name: "MyWhoosh Standard Bandana",
      description: "MyWhoosh Standard Bandana, a practical choice for managing sweat and enhancing overall comfort while also adding a touch of personal flair.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Standard Bandana - Black.png"
    },
    {
      id: 21,
      name: "MyWhoosh Standard Bandana",
      description: "MyWhoosh Standard Bandana, a practical choice for managing sweat and enhancing overall comfort while also adding a touch of personal flair.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/DMyWhoosh Standard Bandana - Blue.png"
    },
    {
      id: 22,
      name: "MyWhoosh Standard Bandana",
      description: "MyWhoosh Standard Bandana, a practical choice for managing sweat and enhancing overall comfort while also adding a touch of personal flair.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Standard Bandana - Red.png"
    },
    {
      id: 23,
      name: "MyWhoosh Standard Bandana",
      description: "MyWhoosh Standard Bandana, a practical choice for managing sweat and enhancing overall comfort while also adding a touch of personal flair.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Standard Bandana - White.png"
    },
    {
      id: 24,
      name: "MyWhoosh Standard Bandana",
      description: "MyWhoosh Standard Bandana, a practical choice for managing sweat and enhancing overall comfort while also adding a touch of personal flair.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Standard Bandana - Yellow.png"
    },
    {
      id: 25,
      name: "Ekoi S22 Cycling Cap",
      description: "Ekoi S22 Cycling Cap is a classic design which provides comfort, sun protection and style to any cyclists kit.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/Ekoi S22 Cycling Cap - Red.png"
    },
    {
      id: 11,
      name: "Ekoi Aero 15 Helmet",
      description: "Ekoi Aero 15 Helmet combines protection, ergonomics, aerodynamics, versatility and design in a top level helmet.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/Ekoi Aero 15 Helmet - Black.png"
    },
    {
      id: 13,
      name: "Ekoi AERO15 Helmet",
      description: "Ekoi AERO15 Helmet combines protection, ergonomics, aerodynamics, versatility and design in a top level helmet.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/Ekoi AERO15 Helmet - White.png"
    },
    {
      id: 12,
      name: "Ekoi AERO15 Helmet",
      description: "Ekoi AERO15 Helmet combines protection, ergonomics, aerodynamics, versatility and design in a top level helmet.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/Ekoi AERO15 Helmet - Red.png"
    },
    {
      id: 7,
      name: "MyWhoosh Aero Visor",
      description: "MyWhoosh Aero Visor Helemt fetaures a streamlined shape and compact design delivering a versatile helmet suitable for both time trials and other aero applications.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Aero Visor - Black.png"
    },
    {
      id: 8,
      name: "MyWhoosh Aero Visor",
      description: "MyWhoosh Aero Visor Helemt fetaures a streamlined shape and compact design delivering a versatile helmet suitable for both time trials and other aero applications.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Aero Visor - White"
    },
    {
      id: 9,
      name: "MyWhoosh Time Trial Helmet",
      description: "MyWhoosh Time Trial Helmet prioritizes a streamlined and elongated shape to minimize air resistance and enhance speed optimizing aerodynamic performance.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Time Trial Helmet - White.png"
    },
    {
      id: 10,
      name: "MyWhoosh Time Trial Helmet",
      description: "MyWhoosh Time Trial Helmet prioritizes a streamlined and elongated shape to minimize air resistance and enhance speed optimizing aerodynamic performance.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Time Trial Helmet - Yellow.png"
    },
    {
      id: 26,
      name: "Ekoi AERO16 Helmet",
      description: "The Ekoi AERO16 will improve aerodynamics while delivering a lightweight design and the comfort needed for hilly terrain.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/Ekoi AERO16 Helmet - Black Red.png"
    },
    {
      id: 27,
      name: "Ekoi Veloce Helmet",
      description: "Ekoi Veloce Helemt, tested and developed in a wind tunnel with one key goal, aerodynamic efficiency.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/Ekoi Veloce Helmet - White.png"
    },
    {
      id: 28,
      name: "Van Rysel FCR Aero Helmet",
      description: "Van Rysel FCR Aero Helmet. At the highest level, and at high speeds, aerodynamics make all the difference.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/Van Rysel FCR Aero Helmet.png"
    },
    {
      id: 29,
      name: "MyWhoosh Radiance Helmet",
      description: "MyWhoosh Radiance Helmet, style and functionality combined to meet the performance needs of any cyclist.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Radiance Helmet.png"
    },
    {
      id: 30,
      name: "MyWhoosh Desert Sand Helmet",
      description: "MyWhoosh Desert Sand Helmet, classic design and style to meet all riders demands.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/MyWhoosh Desert Sand Helmet.png"
    },
    {
      id: 32,
      name: "ABUS AirBreaker Orange",
      description: "With an innovative Multi Speed design, the AirBreaker always offers the best possible aerodynamics and at the same time ensures optimum ventilation. ",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/ABUS AirBreaker Orange.png"
    },
    {
      id: 33,
      name: "ABUS AirBreaker White",
      description: "With an innovative Multi Speed design, the AirBreaker always offers the best possible aerodynamics and at the same time ensures optimum ventilation.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/ABUS AirBreaker White.png"
    },
    {
      id: 34,
      name: "ABUS GameChanger Black",
      description: "The GameChanger sets new standards in the battle against the wind. With its Multi Position Design, the GameChanger redefines aerodynamics.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/ABUS GameChanger Black.png"
    },
    {
      id: 35,
      name: "ABUS GameChanger Blue",
      description: "The GameChanger sets new standards in the battle against the wind. With its Multi Position Design, the GameChanger redefines aerodynamics.",
      weight: 0,
      thumbnail: "/assets/images/shop/Headgear/ABUS GameChanger Blue.png"
    }
  ],
  gloves: [
    {
      id: 1,
      name: "MyWhoosh Half-Finger Glove",
      description: "MyWhoosh half-finger gloves are designed to provide protection, grip, and comfort with high ventilation. ",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Half-Finger Glove - White.png"
    },
    {
      id: 2,
      name: "MyWhoosh Half-Finger Glove",
      description: "MyWhoosh half-finger gloves are designed to provide protection, grip, and comfort with high ventilation. ",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Half-Finger Glove - Sky Blue.png"
    },
    {
      id: 3,
      name: "MyWhoosh Half-Finger Glove",
      description: "MyWhoosh half-finger gloves are designed to provide protection, grip, and comfort with high ventilation. ",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Half-Finger Glove - Burgundy.png"
    },
    {
      id: 4,
      name: "MyWhoosh Half-Finger Glove",
      description: "MyWhoosh half-finger gloves are designed to provide protection, grip, and comfort with high ventilation. ",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Half-Finger Glove - Moss Green.png"
    },
    {
      id: 5,
      name: "MyWhoosh Half-Finger Glove",
      description: "MyWhoosh half-finger gloves are designed to provide protection, grip, and comfort with high ventilation. ",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Half-Finger Glove - Yellow.png"
    },
    {
      id: 6,
      name: "MyWhoosh Half-Finger Glove",
      description: "MyWhoosh half-finger gloves are designed to provide protection, grip, and comfort with high ventilation. ",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Half-Finger Glove - Red.png"
    },
    {
      id: 7,
      name: "MyWhoosh Half-Finger Glove",
      description: "MyWhoosh half-finger gloves are designed to provide protection, grip, and comfort with high ventilation. ",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Half-Finger Glove - Light Pink.png"
    },
    {
      id: 8,
      name: "MyWhoosh Half-Finger Glove",
      description: "MyWhoosh half-finger gloves are designed to provide protection, grip, and comfort with high ventilation. ",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Half-Finger Glove - Sefo Green.png"
    },
    {
      id: 9,
      name: "MyWhoosh Black/White Glove",
      description: "Go the safe way",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Black/White Glove.png"
    },
    {
      id: 10,
      name: "MyWhoosh Blue Glove",
      description: "Matches those nice blue shirts.",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Blue Glove.png"
    },
    {
      id: 11,
      name: "MyWhoosh Appleblue Seagreen",
      description: "Ultimate glove.",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Appleblue Seagreen.png"
    },
    {
      id: 12,
      name: "MyWhoosh Sprint Green",
      description: "Be fast and aero.",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Sprint Green.png"
    },
    {
      id: 13,
      name: "MyWhoosh Ciclamino",
      description: "Stand out of the crowd.",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Ciclamino.png"
    },
    {
      id: 14,
      name: "MyWhoosh Vuelta Glove",
      description: "For those who lead the pack.",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Vuelta Glove.png"
    },
    {
      id: 15,
      name: "MyWhoosh Flash grey",
      description: "No compremises in performance.",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Flash grey.png"
    },
    {
      id: 16,
      name: "MyWhoosh Desert Storm Glove",
      description: "One for the Team.",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Desert Storm Glove.png"
    },
    {
      id: 17,
      name: "MyWhoosh Radiance Glove",
      description: "MyWhoosh Radiance Glove, style and performance. Everything you require.",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Radiance Glove.png"
    },
    {
      id: 18,
      name: "MyWhoosh Desert Sand Glove",
      description: "MyWhoosh Desert Sand Glove, classic design and fit. Everything you require.",
      thumbnail: "/assets/images/shop/Gloves/MyWhoosh Desert Sand Glove.png"
    }
  ],
  glasses: [
    {
      id: 1,
      name: "MyWhoosh Half-Frame - Black",
      description: "MyWhoosh Half-frame provide a modern and minimalist aesthetic, with a lightweight construction and unobstructed Vision.",
      thumbnail: "/assets/images/shop/Eyewear/MyWhoosh Half-Frame - Black.png"
    },
    {
      id: 2,
      name: "MyWhoosh Full-Frame - Black",
      description: "MyWhoosh Full-Frame feature a lightweight and aerodynamic design, offering a comfortable fit and streamlined design.",
      thumbnail: "/assets/images/shop/Eyewear/MyWhoosh Full-Frame - Black.png"
    },
    {
      id: 3,
      name: "MyWhoosh Full-Frame - Yellow",
      description: "MyWhoosh Full-Frame feature a lightweight and aerodynamic design, offering a comfortable fit and streamlined design.",
      thumbnail: "/assets/images/shop/Eyewear/MyWhoosh Full-Frame - Yellow.png"
    },
    {
      id: 4,
      name: "MyWhoosh Casual",
      description: "MyWhoosh Casual prioritize comfort, style, and practicality with a blend of functionality and style.",
      thumbnail: "/assets/images/shop/Eyewear/MyWhoosh Casual.png"
    },
    {
      id: 5,
      name: "Ekoi Premium 80 Revo Red",
      description: "Ekoi Premium 80 designed with aerodynamics and airflow in mind to produce a performance eyewear product for the most intense rides.",
      thumbnail: "/assets/images/shop/Eyewear/Ekoi Premium 80 Revo Red.png"
    },
    {
      id: 6,
      name: "Ekoi Premium 90 Saphire",
      description: "Ekoi Premium 90 designed for the most demanding competitive riders looking for a 100% performance product, they have an ultra-stable frame and wrap-around, hyper-protective lens.",
      thumbnail: "/assets/images/shop/Eyewear/Ekoi Premium 90 Saphire.png"
    },
    {
      id: 7,
      name: "Van Rysel Perf 900 Light",
      description: "Lightweight, ventilated, and with a sporty look, the 900 Perf Light glasses fall into the featherweight category.",
      thumbnail: "/assets/images/shop/Eyewear/Van Rysel Perf 900 Light.png"
    },
    {
      id: 8,
      name: "SCICON Aeroscope Performance",
      description: "The Aeroscope Performance sunglasses extends beyond the expected and delivers tailored precision for the ultimate sports experience.",
      thumbnail: "/assets/images/shop/Eyewear/SCICON Aeroscope Performance.png"
    },
    {
      id: 9,
      name: "SCICON Aeroshade Kunken",
      description: "Developed with vision enhancing engineering, the Aeroshade Kunken Sport Performance Sunglasses with a cylindrical shield lens will improve your vision and performance.",
      thumbnail: "/assets/images/shop/Eyewear/SCICON Aeroshade Kunken.png"
    }
  ],
  hair: [
    {
      id: 0,
      name: "None",
      description: "If you choose 'None', your avatar will have no hair. Let your style reflect your personality."
    },
    {
      id: 1,
      name: "Crew Cut",
      description: "Customize your avatar's style with trendy haircuts - long, short, or quirky. Let your virtual locks reflect your personality!"
    },
    {
      id: 2,
      name: "Ponytail",
      description: "Customize your avatar's style with trendy haircuts - long, short, or quirky. Let your virtual locks reflect your personality!"
    },
    {
      id: 3,
      name: "Braids",
      description: "Customize your avatar's style with trendy haircuts - long, short, or quirky. Let your virtual locks reflect your personality!"
    },
    {
      id: 4,
      name: "Short Afro",
      description: "Customize your avatar's style with trendy haircuts - long, short, or quirky. Let your virtual locks reflect your personality!"
    },
    {
      id: 5,
      name: "Side Fringe",
      description: "Customize your avatar's style with trendy haircuts - long, short, or quirky. Let your virtual locks reflect your personality!"
    },
    {
      id: 6,
      name: "Pogacar Hair",
      description: "Hair made specially for Pogacar"
    }
  ],
  facialHair: [
    {
      id: 0,
      name: "None",
      description: "If you choose 'None', your avatar will have no facial hair. Let your style reflect your personality."
    },
    {
      id: 1,
      name: "Full Beard",
      description: "Add character to your avatar with stylish facial hair - beards, moustaches, or stubble. Express your virtual personality!"
    },
    {
      id: 2,
      name: "Circle Beard",
      description: "Add character to your avatar with stylish facial hair - beards, moustaches, or stubble. Express your virtual personality!"
    },
    {
      id: 3,
      name: "Zappa",
      description: "Add character to your avatar with stylish facial hair - beards, moustaches, or stubble. Express your virtual personality!"
    },
    {
      id: 4,
      name: "Classic Goatee",
      description: "Add character to your avatar with stylish facial hair - beards, moustaches, or stubble. Express your virtual personality!"
    },
    {
      id: 5,
      name: "Short Goatee",
      description: "Add character to your avatar with stylish facial hair - beards, moustaches, or stubble. Express your virtual personality!"
    },
    {
      id: 6,
      name: "Chevron",
      description: "Add character to your avatar with stylish facial hair - beards, moustaches, or stubble. Express your virtual personality!"
    },
    {
      id: 7,
      name: "Soul Patch",
      description: "Add character to your avatar with stylish facial hair - beards, moustaches, or stubble. Express your virtual personality!"
    }
  ],
  jerseys: [
    {
      id: 50,
      name: "UAE Team Emirates Jersey",
      description: "UAE Team Emirates 2024 Team Jersey. Ride with the best.",
      thumbnail: "/assets/images/shop/Jersey/UAE Team Emirates Jersey.png"
    },
    {
      id: 51,
      name: "MyWhoosh Explore Jersey",
      description: "White MyWhoosh Explore Jersey provides comfort and functionality.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Explore Jersey-White.png"
    },
    {
      id: 52,
      name: "MyWhoosh Explore Jersey",
      description: "Green MyWhoosh Explore Jersey provides comfort and functionality.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Explore Jersey-Green.png"
    },
    {
      id: 54,
      name: "MyWhoosh Explore Jersey",
      description: "Sky Blue MyWhoosh Explore Jersey provides comfort and functionality.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Explore Jersey-SkyBlue.png"
    },
    {
      id: 55,
      name: "MyWhoosh Explore Jersey",
      description: "Burgundy MyWhoosh Explore Jersey provides comfort and functionality.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Explore Jersey-Burgundy.png"
    },
    {
      id: 56,
      name: "MyWhoosh Race Jersey",
      description: "Desert Yellow MyWhoosh Race Jersey is aerodynamic while retaining comfort and style.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Race Jersey-Yellow.png"
    },
    {
      id: 57,
      name: "MyWhoosh Race Jersey",
      description: "Red MyWhoosh Race Jersey is aerodynamic while retaining comfort and style.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Race Jersey-Red.png"
    },
    {
      id: 58,
      name: "MyWhoosh Race Jersey",
      description: "Orange Burgundy MyWhoosh Race Jersey is aerodynamic while retaining comfort and style.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Race Jersey-Orange.png"
    },
    {
      id: 59,
      name: "MyWhoosh Race Jersey",
      description: "Seafoam Green MyWhoosh Race Jersey is aerodynamic while retaining comfort and style.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Race Jersey-Seafoam.png"
    },
    {
      id: 60,
      name: "MyWhoosh Race Jersey",
      description: "Light Pink MyWhoosh Race Jersey is aerodynamic while retaining comfort and style.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Race Jersey-LightPink.png"
    },
    {
      id: 61,
      name: "MyWhoosh Race Jersey",
      description: "Dark Blue MyWhoosh Race Jersey is aerodynamic while retaining comfort and style.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Race Jersey-DarkBlue.png"
    },
    {
      id: 62,
      name: "MyWhoosh Team White Jersey",
      description: "MyWhoosh Team Issue White Jersey, ride with us!",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Team White Jersey.png"
    },
    {
      id: 63,
      name: "MyWhoosh Team Black Jersey",
      description: "MyWhoosh Team Issue Black Jersey, ride with us!",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Team Black Jersey.png"
    },
    {
      id: 73,
      name: "MyWhoosh Green Rush",
      description: "MyWhoosh Green Rush, get there Fast",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Green Rush.png"
    },
    {
      id: 74,
      name: "MyWhoosh Dots Jersey",
      description: "MyWhoosh Dots Jersey, the ulitmate KOM jersey",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Dots Jersey.png"
    },
    {
      id: 75,
      name: "MyWhoosh Snake Lines",
      description: "MyWhoosh Snake Lines Jersey, as fast as a snake.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Snake Lines.png"
    },
    {
      id: 77,
      name: "MyWhoosh Rainbow Quest Jersey",
      description: "MyWhoosh Rainbow Quest Jersey, ambition is everything.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Rainbow Quest Jersey.png"
    },
    {
      id: 79,
      name: "MyWhoosh Afterburn",
      description: "MyWhoosh Afterburn Jersey, the Rush of Speed.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Afterburn.png"
    },
    {
      id: 80,
      name: "MyWhoosh Blue Thunder",
      description: "MyWhoosh Blue Thunder, bring on the storm.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Blue Thunder.png"
    },
    {
      id: 81,
      name: "MyWhoosh Youth Jersey",
      description: "MyWhoosh Youth Jersey, white gives youth power.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Youth Jersey.png"
    },
    {
      id: 82,
      name: "MyWhoosh Orange is new black",
      description: "MyWhoosh Orange is the new black Jersey, standout from the crowd.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Orange is new black.png"
    },
    {
      id: 83,
      name: "MyWhoosh Cyclone",
      description: "MyWhoosh Cyclone Jersey, the unstoppable force.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Cyclone.png"
    },
    {
      id: 84,
      name: "MyWhoosh Chase Jersey",
      description: "MyWhoosh Chase Jersey, with a chase you win the race.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Chase Jersey.png"
    },
    {
      id: 85,
      name: "MyWhoosh Bright in Pink",
      description: "MyWhoosh Bright in Pink Jersey, light up that ride.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Bright in Pink.png"
    },
    {
      id: 86,
      name: "MyWhoosh Flashes of Green",
      description: "MyWhoosh Flashes of Green Jersey, sprint to the line.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Flashes of Green.png"
    },
    {
      id: 87,
      name: "MyWhoosh Marine",
      description: "MyWhoosh Marine Jersey, fight like a marine.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Marine.png"
    },
    {
      id: 88,
      name: "MyWhoosh Alula Jersey",
      description: "MyWhoosh AlUla Jersey Blue, an oasis to discover.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Alula Jersey-Blue.png"
    },
    {
      id: 89,
      name: "MyWhoosh Alula Jersey",
      description: "MyWhoosh AlUla Jersey Green, an oasis to discover.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Alula Jersey-Green.png"
    },
    {
      id: 90,
      name: "MyWhoosh Alula Jersey",
      description: "MyWhoosh AlUla Jersey Orange, an oasis to discover.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Alula Jersey-Orange.png"
    },
    {
      id: 91,
      name: "MyWhoosh Alula Jersey",
      description: "MyWhoosh AlUla Jersey Red, an oasis to discover.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Alula Jersey-Red.png"
    },
    {
      id: 92,
      name: "MyWhoosh Alula Jersey",
      description: "MyWhoosh AlUla Jersey White, an oasis to discover.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Alula Jersey-White.png"
    },
    {
      id: 93,
      name: "MyWhoosh Alula Jersey",
      description: "MyWhoosh AlUla Jersey Yellow, an oasis to discover.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Alula Jersey-Yellow.png"
    },
    {
      id: 94,
      name: "MyWhoosh Blue Zephyr",
      description: "MyWhoosh Blue Zephyr Jersey, breeze over the line.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Blue Zephyr.png"
    },
    {
      id: 95,
      name: "MyWhoosh Camouflage",
      description: "MyWhoosh Camouflage Jersey, no more hiding.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Camouflage.png"
    },
    {
      id: 101,
      name: "MyWhoosh Flower Power",
      description: "MyWhoosh Flower Power Jersey, sting like a bee.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Flower Power.png"
    },
    {
      id: 102,
      name: "MyWhoosh Desert Flame",
      description: "MyWhoosh Desert Flame Jersey, burn bright.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Desert Flame.png"
    },
    {
      id: 107,
      name: "UAE Team ADQ Jersey",
      description: "UAE Team ADQ 2024 Team Jersey. Ride with the best.",
      thumbnail: "/assets/images/shop/Jersey/UAE Team ADQ Jersey.png"
    },
    {
      id: 110,
      name: "Ekoi Blue Jersey",
      description: "Always in search of performance, Ekoi Blue Jersey provides optimum comfort and performance.",
      thumbnail: "/assets/images/shop/Jersey/Ekoi Blue Jersey.png"
    },
    {
      id: 111,
      name: "Ekoi Violet Jersey",
      description: "Always in search of performance, Ekoi Violet Jersey provides optimum comfort and performance.",
      thumbnail: "/assets/images/shop/Jersey/Ekoi Violet Jersey.png"
    },
    {
      id: 112,
      name: "Ekoi Turquoise Jersey",
      description: "Always in search of performance, Ekoi Turquoise Jersey provides optimum comfort and performance.",
      thumbnail: "/assets/images/shop/Jersey/Ekoi Turquoise Jersey.png"
    },
    {
      id: 113,
      name: "Beastmode Jersey",
      description: "Get caught up in beastmode and test your limits with the lightweight Beastmode Jersey.",
      thumbnail: "/assets/images/shop/Jersey/Beastmode Jersey.png"
    },
    {
      id: 138,
      name: "UAE Team ADQ Jersey White",
      description: "UAE Team ADQ Classic White Team Jersey. Ride with the best.",
      thumbnail: "/assets/images/shop/Jersey/UAE Team ADQ Jersey White.png"
    },
    {
      id: 139,
      name: "Ventum xWYN Rose Jersey",
      description: "Ventum xWYN Rose Jersey, a race-cut modern jersey for a slim, aerodynamic fit.",
      thumbnail: "/assets/images/shop/Jersey/Ventum xWYN Rose Jersey.png"
    },
    {
      id: 140,
      name: "Ventum xWYN Sage Jersey",
      description: "Ventum xWYN Sage Jersey, a race-cut modern jersey for a slim, aerodynamic fit.",
      thumbnail: "/assets/images/shop/Jersey/Ventum xWYN Sage Jersey.png"
    },
    {
      id: 141,
      name: "MyWhoosh Team Red Jersey",
      description: "MyWhoosh Team Red Jersey, ride with us!",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Team Red Jersey.png"
    },
    {
      id: 142,
      name: "MyWhoosh Team Bronze Jersey",
      description: "MyWhoosh Team Bronze Jersey, ride with us!",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Team Bronze Jersey.png"
    },
    {
      id: 143,
      name: "Zycle Team Jersey",
      description: "Zycle Team Jersey, Cycle with Zycle.",
      thumbnail: "/assets/images/shop/Jersey/Zycle Team Jersey.png"
    },
    {
      id: 144,
      name: "Look Delko Classic Jersey",
      description: "Look Delko Classic Jersey, timeless performance and design.",
      thumbnail: "/assets/images/shop/Jersey/Look Delko Classic Jersey.png"
    },
    {
      id: 145,
      name: "Wahoo Le Col Team Jersey",
      description: "Wahoo Le Col Team Jersey, designed to train and race indoors.",
      thumbnail: "/assets/images/shop/Jersey/Wahoo Le Col Team Jersey.png"
    },
    {
      id: 146,
      name: "Van Rysel Jersey",
      description: "Decathlon Van Rysel Jersey, designed for cyclists who want to push their limits.",
      thumbnail: "/assets/images/shop/Jersey/Van Rysel Jersey.png"
    },
    {
      id: 149,
      name: "MyWhoosh Desert Sand",
      description: "MyWhoosh Desert Sand Jersey, capture the relentless heat and beauty.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Desert Sand.png"
    },
    {
      id: 150,
      name: "MyWhoosh Radiance",
      description: "MyWhoosh Radiance Jersey, ride in the brilliance and serene glow.",
      thumbnail: "/assets/images/shop/Jersey/MyWhoosh Radiance.png"
    }
  ],
  socks: [
    {
      id: 1,
      name: "MyWhoosh Explore Sock",
      description: "MyWhoosh Explore socks are designed to provide comfort and support during longer rides, they feature a combination of breathable and moisture-wicking materials to keep feet cool and dry over extended periods.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Explore Sock - White.png"
    },
    {
      id: 2,
      name: "MyWhoosh Explore Sock",
      description: "MyWhoosh Explore socks are designed to provide comfort and support during longer rides, they feature a combination of breathable and moisture-wicking materials to keep feet cool and dry over extended periods.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Explore Sock - Black.png"
    },
    {
      id: 3,
      name: "MyWhoosh Explore Sock",
      description: "MyWhoosh Explore socks are designed to provide comfort and support during longer rides, they feature a combination of breathable and moisture-wicking materials to keep feet cool and dry over extended periods.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Explore Sock - Blue.png"
    },
    {
      id: 4,
      name: "MyWhoosh Explore Sock",
      description: "MyWhoosh Explore socks are designed to provide comfort and support during longer rides, they feature a combination of breathable and moisture-wicking materials to keep feet cool and dry over extended periods.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Explore Sock - Burgundy.png"
    },
    {
      id: 5,
      name: "MyWhoosh Explore Sock",
      description: "MyWhoosh Explore socks are designed to provide comfort and support during longer rides, they feature a combination of breathable and moisture-wicking materials to keep feet cool and dry over extended periods.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Explore Sock - Light Yellow.png"
    },
    {
      id: 6,
      name: "MyWhoosh Explore Sock",
      description: "MyWhoosh Explore socks are designed to provide comfort and support during longer rides, they feature a combination of breathable and moisture-wicking materials to keep feet cool and dry over extended periods.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Explore Sock - Moss Green.png"
    },
    {
      id: 7,
      name: "MyWhoosh Race Sock",
      description: "MyWhoosh Race Socks are specialized, performance-oriented socks designed for competitive cycling, crafted with lightweight and breathable materials to keep feet cool and dry during intense races.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Race Sock - Orange.png"
    },
    {
      id: 8,
      name: "MyWhoosh Race Sock",
      description: "MyWhoosh Race Socks are specialized, performance-oriented socks designed for competitive cycling, crafted with lightweight and breathable materials to keep feet cool and dry during intense races.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Race Sock - Red.png"
    },
    {
      id: 9,
      name: "MyWhoosh Race Sock",
      description: "MyWhoosh Race Socks are specialized, performance-oriented socks designed for competitive cycling, crafted with lightweight and breathable materials to keep feet cool and dry during intense races.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Race Sock - Desert Yellow.png"
    },
    {
      id: 10,
      name: "MyWhoosh Race Sock",
      description: "MyWhoosh Race Socks are specialized, performance-oriented socks designed for competitive cycling, crafted with lightweight and breathable materials to keep feet cool and dry during intense races.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Race Sock - Sefo Green.png"
    },
    {
      id: 11,
      name: "MyWhoosh Race Sock",
      description: "MyWhoosh Race Socks are specialized, performance-oriented socks designed for competitive cycling, crafted with lightweight and breathable materials to keep feet cool and dry during intense races.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Race Sock - Light Pink.png"
    },
    {
      id: 12,
      name: "MyWhoosh Race Sock",
      description: "MyWhoosh Race Socks are specialized, performance-oriented socks designed for competitive cycling, crafted with lightweight and breathable materials to keep feet cool and dry during intense races.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Race Sock - Dark Blue.png"
    },
    {
      id: 13,
      name: "MyWhoosh Radiance Sock",
      description: "MyWhoosh Radiance socks provide comfort, style and a classic race fit.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Radiance Sock.png"
    },
    {
      id: 14,
      name: "MyWhoosh Desert Sand Sock",
      description: "MyWhoosh Desert Sand socks provide comfort, style and a classic race fit.",
      thumbnail: "/assets/images/shop/Socks/MyWhoosh Desert Sand Sock.png"
    }
  ],
  shoes: [
    {
      id: 1,
      name: "MyWhoosh Lace Up Explore Shoe",
      description: "MyWhoosh Lace Up Explore Shoes feature a balance between stiffness for efficient power transfer and flexibility for prolonged comfort.",
      thumbnail: "/assets/images/shop/Shoes/MyWhoosh Lace Up Explore Shoe - Black.png"
    },
    {
      id: 2,
      name: "MyWhoosh Lace Up Explore Shoe",
      description: "MyWhoosh Lace Up Explore Shoes feature a balance between stiffness for efficient power transfer and flexibility for prolonged comfort.",
      thumbnail: "/assets/images/shop/Shoes/MyWhoosh Lace Up Explore Shoe - White.png"
    },
    {
      id: 3,
      name: "MyWhoosh Race Shoe",
      description: "MyWhoosh Race Shoes are crafted to optimize performance, stiffness and comfort for cyclists during intense efforts.",
      thumbnail: "/assets/images/shop/Shoes/MyWhoosh Race Shoe - Black.png"
    },
    {
      id: 4,
      name: "MyWhoosh Race Shoe",
      description: "MyWhoosh Race Shoes are crafted to optimize performance, stiffness and comfort for cyclists during intense efforts.",
      thumbnail: "/assets/images/shop/Shoes/MyWhoosh Race Shoe - White.png"
    },
    {
      id: 5,
      name: "MyWhoosh Race Shoe",
      description: "MyWhoosh Race Shoes are crafted to optimize performance, stiffness and comfort for cyclists during intense efforts.",
      thumbnail: "/assets/images/shop/Shoes/MyWhoosh Race Shoe - Yellow.png"
    },
    {
      id: 11,
      name: "Ekoi R4 Road Shoe",
      description: "If you seek the perfect pedal stroke in a subtle race shoe offering exceptional comfort and high-performance, then the new Ekoi R4 road shoes have been designed for you.",
      thumbnail: "/assets/images/shop/Shoes/Ekoi R4 Road Shoe - Blue.png"
    },
    {
      id: 12,
      name: "Ekoi Tri R4 Shoe",
      description: "The new Ekoi R4 Tri shoe is aimed at regular triathletes looking for lightweight, comfortable, high-performance equipment maximizing drying and optimizing transition times.",
      thumbnail: "/assets/images/shop/Shoes/Ekoi R4 Tri Shoe.png"
    },
    {
      id: 15,
      name: "VanRyselRCRPro_Black",
      description: "The Van Rysel RCR Pro Shoe is characterised by a comfy fit and a highly rigid, ventilated 100% carbon sole. Developed with and chosen by pros.",
      thumbnail: "/assets/images/shop/Shoes/Van Rysel RCR Pro Shoe - Black.png"
    },
    {
      id: 16,
      name: "VanRyselRCRPro_White",
      description: "The Van Rysel RCR Pro Shoe is characterised by a comfy fit and a highly rigid, ventilated 100% carbon sole. Developed with and chosen by pros.",
      thumbnail: "/assets/images/shop/Shoes/Van Rysel RCR Pro Shoe - White.png"
    },
    {
      id: 17,
      name: "VELOKICKS Season 1",
      description: "Designed to be bold,  these shoes were created so that the only limit on their expression is you.",
      thumbnail: "/assets/images/shop/Shoes/VELOKICKS Season 1.png"
    },
    {
      id: 18,
      name: "VELOKICKS Season 2",
      description: "Designed to be bold,  these shoes were created so that the only limit on their expression is you.",
      thumbnail: "/assets/images/shop/Shoes/VELOKICKS Season 2.png"
    },
    {
      id: 23,
      name: "MyWhoosh Radiance Shoe",
      description: "MyWhoosh Radiance Shoe, style and striking design, with the fit and functionality of a premium race shoe.",
      thumbnail: "/assets/images/shop/Shoes/MyWhoosh Radiance Shoe.png"
    },
    {
      id: 24,
      name: "MyWhoosh Desert Sand Shoe",
      description: "MyWhoosh Desert Sand Shoe, style and striking design, with the fit and functionality of a premium race shoe.",
      thumbnail: "/assets/images/shop/Shoes/MyWhoosh Desert Sand Shoe.png"
    }
  ],
  head: [
    {
      id: 0,
      name: "Skin Tone 1",
      description: "Choose your avatar to personalize your virtual representation in MyWhoosh. When others see your avatar, they associate it with you."
    },
    {
      id: 1,
      name: "Skin Tone 2",
      description: "Choose your avatar to personalize your virtual representation in MyWhoosh. When others see your avatar, they associate it with you."
    },
    {
      id: 2,
      name: "Skin Tone 3",
      description: "Choose your avatar to personalize your virtual representation in MyWhoosh. When others see your avatar, they associate it with you."
    },
    {
      id: 3,
      name: "Skin Tone 4",
      description: "Choose your avatar to personalize your virtual representation in MyWhoosh. When others see your avatar, they associate it with you."
    },
    {
      id: 4,
      name: "Pogacar",
      description: "A custom avatar, just for Pogacar"
    }
  ]
};

export default InGameShopData;
